import { useEffect, useState } from 'react';

import {
  Typography,
  Descriptions,
  Modal,
  Skeleton,
  Alert,
  Select,
  Table,
  Tabs,
  Form,
  Popconfirm,
  Card,
  notification,
} from 'antd';
import { Link } from 'react-router-dom';
import BreadcrumbContainer from '../../containers/Breadcrumb';
import AjaxTable from '../../components/AjaxTable';
import {
  getInfo,
  getSummary,
  ajaxTable,
  contractsTable,
  getSTSummary,
  downloadRegularFile,
  uploadRegularFile,
  deleteFile,
  downloadAssignedFile,
  downloadReviewedFile,
  assignFile,
  downloadIrregularFile,
  uploadIrregularFile,
} from '../../api/module/mass_product_approval';

import { CustomButton, TextOrLoading } from '../../components';
import { catchException, IsRole } from '../../utils/helpers/helpers';
import INTERNAL_LINKS from '../../enums/InternalLinks';
import { useParams } from 'react-router-dom';
import { CustomTooltip } from '../../components/CustomTooltip';

import dayjs from 'dayjs';
import { CheckOutlined } from '@ant-design/icons';
import CustomUpload from '../../components/CustomUpload';
import MESSAGES from '../../enums/Messages';

const { Title, Text } = Typography;

const breadcrumbItems = [
  {
    text: 'Aprobación de productos y/o entregables y gastos',
    to: INTERNAL_LINKS.PRODUCT_APPROVAL,
  },
  {
    text: 'Generación de archivo masivo para Aprobación de productos',
  },
];

const contractsColumns = [
  {
    title: 'Nombres y Apellidos',
    dataIndex: 'nombre_completo',
  },
  {
    title: 'Tipo doc',
    dataIndex: 'tipo_identificacion',
  },
  {
    title: 'Nro. documento',
    dataIndex: 'numero_identificacion',
  },
  {
    title: 'Nro. Contrato',
    dataIndex: 'numero_contrato',
    align: 'center',
  },
  {
    title: '# Pago',
    dataIndex: 'numero',
  },
  {
    title: (
      <>
        Estado pago
        <CustomTooltip
          onClick={() =>
            Modal.info({
              title: 'Estados se calculan automático:',
              content: (
                <ul>
                  <li>
                    Aprobado: Todos los estados de los productos/gastos son
                    Aprobado total
                  </li>
                  <li>
                    Aprobado temporal: (no es definitivo-es editable el estado):
                    Al menos un producto/gasto sea Condicionado o Pendiente
                  </li>
                  <li>
                    Aprobado con novedad: (definitivo-sin edición el estado): Al
                    menos un producto/gasto es Aprobado incompleto, Aprobado
                    parcial, No aprobado y/o No entregado
                  </li>
                  <li>
                    No entregado: Todos los productos/gastos de ese pago es "No
                    entregado"
                  </li>
                  <li>
                    No aprobado: Los únicos estados para los productos/gastos
                    son "No entregado" y "No aprobado"
                  </li>
                  <li>Borrador: Aún no se envía a pago </li>
                </ul>
              ),
            })
          }
          title={<>Estados se calculan automático...</>}
        />
      </>
    ),
    dataIndex: 'estado_nombre',
    render: (t, record) => (
      <>
        {t}{' '}
        {record.eb_nombre ? (
          <CustomTooltip
            title={`El estado en borrador es: ${record.eb_nombre}`}
          />
        ) : null}
      </>
    ),
  },
  {
    title: 'Aprobado por',
    dataIndex: 'aprobador_nombre',
    align: 'center',
  },
  {
    title: 'Restricción por',
    dataIndex: 'descripcion',
  },
];

export default function MassProductApprovalForm() {
  let { id } = useParams();

  const [info, setInfo] = useState();
  const [payNum, setPayNum] = useState();
  const [summaryData, setSummaryData] = useState();
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [reloadSource, setReloadSource] = useState(false);

  const [detailModal, setDetailModal] = useState(false);

  const [irregular, setIrregular] = useState(false);

  const [loadingFile, setLoadingFile] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadingAssigned, setLoadingAssigned] = useState(false);
  const [loadingReviewed, setLoadingReviewed] = useState(false);

  const [fileResponse, setFileResponse] = useState();
  const [loadingFRM, setLoadingFRM] = useState(false);

  const [superUser] = useState(IsRole(6));

  useEffect(() => {
    let fetchID = id;
    async function fetchData() {
      setInfo();
      setPayNum();
      try {
        const res = await getInfo(id);
        if (fetchID === id)
          setInfo({
            ...res.data,
            pendiente: {
              ...res.data.pendiente,
              has_regular: (res.data?.pendiente?.has_regular || '').split(','),
            },
          });
      } catch (error) {
        catchException(error);
      }
    }
    fetchData();
  }, [id]);

  function removeFirst(arr, value) {
    const index = arr.indexOf(value);
    if (index === -1) return arr.slice(); // no change
    return [...arr.slice(0, index), ...arr.slice(index + 1)];
  }

  const doDeleteFile = async (record) => {
    try {
      setLoadingDelete(record.id);
      await deleteFile(record.id);
      if (record.unicamente_sin_tope) {
        setInfo((i) => ({
          ...i,
          pendiente: {
            ...i.pendiente,
            has_ust: i.pendiente.has_ust - 1,
          },
        }));
      } else {
        setInfo((i) => ({
          ...i,
          pendiente: {
            ...i.pendiente,
            has_regular: removeFirst(
              i.pendiente.has_regular,
              record.pago_numero.toString(),
            ),
          },
        }));
      }
      setLoadingDelete();
      setReloadSource({});
    } catch (error) {
      setLoadingDelete();
      catchException(error, MESSAGES.DESC_ERROR_DELETE_MSG);
    }
  };

  const downloadAssigned = async (record) => {
    try {
      setLoadingAssigned(record.id);
      const response = await downloadAssignedFile(record.id);
      const link = document.createElement('a');
      link.href = response.data.url;
      link.download = record.nombre;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      catchException(error, MESSAGES.DESC_ERROR_GET_MSG);
    } finally {
      setLoadingAssigned();
    }
  };

  const downloadReviewed = async (record) => {
    try {
      setLoadingReviewed(record.id);
      let response = await downloadReviewedFile(record.id);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `revision_${record.nombre}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      setLoadingReviewed();
    } catch (error) {
      catchException(error, MESSAGES.DESC_ERROR_GET_MSG);
    }
  };

  const columns = [
    {
      title: 'Pago',
      dataIndex: 'pago_numero',
      align: 'center',
    },
    {
      title: 'Nombre del archivo',
      dataIndex: 'nombre',
      align: 'center',
      render: (t) => (t ? t : 'Pendiente'),
    },
    {
      title: 'Usuario',
      dataIndex: 'usuario_nombre',
      align: 'center',
    },
    {
      title: 'Fecha y hora cargue',
      dataIndex: 'fecha_archivo',
      render: (d) => (d ? dayjs(d).format('YYYY-MM-DD hh:mm') : 'Pendiente'),
      align: 'center',
    },
    {
      title: 'Cantidad total de registros',
      dataIndex: 'registros',
      width: '8rem',
      align: 'center',
    },
    {
      title: 'Registros aprobados',
      dataIndex: 'aprobados',
      width: '8rem',
      align: 'center',
    },
    {
      title: 'Registros con errores',
      dataIndex: 'con_error',
      width: '8rem',
      align: 'center',
    },
    {
      title: (
        <>
          Archivo revisado
          <CustomTooltip title="Puede dar clic en los botones para descargar el archivo" />
        </>
      ),
      key: 'download',
      width: '8rem',
      align: 'center',
      render: (_, record) =>
        !record.asignado ? (
          <>
            {superUser && (
              <Popconfirm
                title={MESSAGES.DELETE_CONFIRM_MSG}
                onConfirm={() => doDeleteFile(record)}
              >
                <CustomButton
                  text="Eliminar archivo"
                  danger
                  type="default"
                  htmlType="button"
                  loading={loadingDelete === record.id}
                  disabled={loadingDelete}
                  style={{ marginBottom: 10 }}
                />
              </Popconfirm>
            )}
            <CustomButton
              text="Revisar"
              danger
              type="default"
              htmlType="button"
              onClick={() => downloadReviewed(record)}
              loading={loadingReviewed}
              disabled={loadingDelete || loadingReviewed}
            />
          </>
        ) : (
          <CustomButton
            type="default"
            htmlType="button"
            block
            loading={record.id === loadingAssigned}
            disabled={loadingAssigned}
            onClick={() => downloadAssigned(record)}
            text={
              <>
                <CheckOutlined /> <strong> Datos ya cargados </strong>
              </>
            }
          />
        ),
    },
  ];

  const summaryColumns = [
    {
      title: 'Contratistas con contrato',
      key: 'detail',
      render: (_t, _record, i) =>
        irregular ? (
          i === 0 ? (
            'Total contratistas para este pago'
          ) : i === 1 ? (
            <>
              Con restricciones{' '}
              <CustomTooltip
                title={
                  <>
                    Restricciones <br />
                    <ul>
                      <li>Modificación en curso</li>
                      <li>Acta de terminación en proceso o ya firmada</li>
                      <li>Aprobaciones en proceso</li>
                    </ul>
                  </>
                }
              />
            </>
          ) : (
            'Registros a descargar en archivo Excel'
          )
        ) : i === 0 ? (
          'Total contratistas para este pago'
        ) : i === 1 ? (
          <>
            Con restricciones{' '}
            <CustomTooltip
              title={
                <>
                  Restricciones <br />
                  <ul>
                    <li>Modificación en curso</li>
                    <li>Acta de terminación en proceso o ya firmada</li>
                    <li>Aprobaciones ya realizadas o en proceso</li>
                  </ul>
                </>
              }
            />
          </>
        ) : (
          'Registros a descargar en archivo Excel'
        ),
    },
    {
      title: 'Contratistas',
      dataIndex: 'c',
      align: 'center',
    },
    {
      title: '# productos',
      dataIndex: 'p',
      align: 'center',
    },
    {
      title: 'Acciones',
      key: 'actions',
      align: 'center',
      render: (_t, record, i) =>
        i === 1 && record.c > 0 ? (
          <CustomButton
            text="Ver"
            type="default"
            htmlType="button"
            onClick={() => setDetailModal(true)}
          />
        ) : null,
    },
  ];

  const onSummary = async () => {
    try {
      setSummaryLoading(true);
      const { data: resData } = irregular
        ? await getSTSummary(info.cargo_id)
        : await getSummary(info.cargo_id, payNum);
      setSummaryData(resData);
    } catch (error) {
      catchException(error);
    } finally {
      setSummaryLoading(false);
    }
  };

  const downloadExcel = async () => {
    try {
      setLoadingFile(true);
      if (irregular) {
        let response = await downloadIrregularFile({ cargo: info.cargo_id });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `masivo_sintope_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        setInfo((i) => ({
          ...i,
          pendiente: {
            ...i.pendiente,
            has_ust: i.pendiente.has_ust + 1,
          },
        }));
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        let response = await downloadRegularFile({
          cargo: info.cargo_id,
          pago_numero: payNum,
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `masivo_pago_${payNum}_${dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`,
        );
        document.body.appendChild(link);
        link.click();
        setInfo((i) => ({
          ...i,
          pendiente: {
            ...i.pendiente,
            has_regular: [...i.pendiente.has_regular, payNum.toString()],
          },
        }));
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
      setLoadingFile(false);
      setSummaryData();
      setReloadSource({});
    } catch (error) {
      setLoadingFile(false);
      catchException(error);
    }
  };

  const doUploadRegularFile = async (data) => {
    try {
      setLoadingFile(true);
      const formData = new FormData();

      formData.append('archivo', data.fileList[0].originFileObj);
      formData.append('cargo', info.cargo_id);
      formData.append('pago_numero', payNum);
      const { data: resData } = await uploadRegularFile(formData);
      setFileResponse({ ...resData, unicamente_sin_tope: false });
      setLoadingFile(false);
    } catch (error) {
      setLoadingFile(false);
      catchException(error, MESSAGES.DESC_ERROR_POST_MSG);
    }
  };

  const doUploadIrregularFile = async (data) => {
    try {
      setLoadingFile(true);
      const formData = new FormData();

      formData.append('archivo', data.fileList[0].originFileObj);
      formData.append('cargo', info.cargo_id);
      const { data: resData } = await uploadIrregularFile(formData);
      setFileResponse({ ...resData, unicamente_sin_tope: true });
      setLoadingFile(false);
    } catch (error) {
      setLoadingFile(false);
      catchException(error, MESSAGES.DESC_ERROR_POST_MSG);
    }
  };

  const doCancelUpload = async () => {
    setLoadingFRM(2);
    // File is no longer deleted by this action
    // const mockRecord = {
    //   id: fileResponse.id,
    //   unicamente_sin_tope: fileResponse.unicamente_sin_tope,
    //   pago_numero: payNum,
    // };
    // doDeleteFile(mockRecord);
    setLoadingFRM(false);
    setFileResponse();
    setReloadSource({}); // Due to the file no longer being deleted
  };

  const doAssignFile = async () => {
    setLoadingFRM(1);
    try {
      await assignFile(fileResponse.id);
      setReloadSource({});
      setInfo();
      setPayNum();
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_MSG,
        duration: 2,
      });
      const res = await getInfo(id);
      setInfo({
        ...res.data,
        pendiente: {
          ...res.data.pendiente,
          has_regular: (res.data?.pendiente?.has_regular || '').split(','),
        },
      });
    } catch (error) {
      catchException(error, MESSAGES.DESC_ERROR_POST_MSG);
    } finally {
      setLoadingFRM(false);
      setFileResponse();
    }
  };

  const tabItems = [
    {
      key: '1',
      label: 'Contratos regulares',
      disabled: summaryLoading || loadingFile || info?.pagos?.length < 1,
      children: info ? (
        <Card>
          <Alert
            showIcon
            message="Recuerde que"
            description={
              <ul>
                <li>
                  Para descargar plantillas o cargar archivos de pagos masivos
                  debe seleccionar el número de pago
                </li>
                <li>Este módulo no muestra contratos 100% sin tope</li>
              </ul>
            }
          />
          <br />
          <Text>Seleccione el pago a aprobar masivamente</Text>
          <br />
          <Select
            options={info.pagos.map((v) => ({ value: v, label: `Pago ${v}` }))}
            style={{ width: '100%' }}
            onChange={setPayNum}
            placeholder="Seleccione el pago que desea aprobar"
          />
          <br />
          <br />
          {payNum && (
            <>
              <CustomButton
                type="default"
                htmlType="button"
                text="Ver detalle / Descargar plantilla"
                disabled={summaryLoading || loadingFile}
                loading={summaryLoading}
                onClick={onSummary}
                className="back-button"
              />
              <br />
              <br />

              {info.pendiente?.has_regular.includes(payNum.toString()) ? (
                <Form
                  onFinish={(e) => doUploadRegularFile(e.archivo)}
                  layout="vertical"
                >
                  <CustomUpload
                    file_type={3}
                    upload_type={2}
                    name="archivo"
                    label="Cargue la plantilla descargada debidamente diligenciada en las columnas de color verde"
                    buttonLabel="Seleccionar archivo a cargar"
                    loading={loadingFile}
                    clearFiles={reloadSource}
                    required
                  />
                  <CustomButton
                    loading={loadingFile}
                    text="Cargar y verificar archivo"
                  />
                </Form>
              ) : null}
            </>
          )}
        </Card>
      ) : null,
    },
    {
      key: '2',
      label: 'Contratos 100% sin topes',
      disabled: summaryLoading || !info?.sin_tope || loadingFile,
      children: info ? (
        <Card>
          <Text>
            Para iniciar con el proceso de calificación masiva, de clic en Ver
            Detalle
          </Text>
          <br />
          <br />
          <CustomButton
            type="default"
            htmlType="button"
            text="Ver detalle / Descargar plantilla"
            disabled={summaryLoading || loadingFile}
            loading={summaryLoading}
            onClick={onSummary}
            className="back-button"
          />
          <br />
          <br />

          {info.pendiente?.has_ust > 0 ? (
            <Form
              onFinish={(e) => doUploadIrregularFile(e.archivo)}
              layout="vertical"
            >
              <CustomUpload
                file_type={3}
                upload_type={2}
                name="archivo"
                label="Cargue la plantilla descargada debidamente diligenciada en las columnas de color verde"
                buttonLabel="Seleccionar archivo a cargar"
                loading={loadingFile}
                clearFiles={reloadSource}
                required
              />
              <CustomButton
                loading={loadingFile}
                text="Cargar y verificar archivo"
              />
            </Form>
          ) : null}
        </Card>
      ) : null,
    },
  ];

  return (
    <>
      <BreadcrumbContainer items={breadcrumbItems} />
      <Title className={'text-uppercase'} level={2}>
        Generación de archivo masivo para Aprobación de productos
      </Title>
      <Descriptions
        layout="horizontal"
        column={2}
        bordered
        styles={{
          label: { width: '20em' },
        }}
      >
        <Descriptions.Item label="Proyecto" span={2}>
          <TextOrLoading text={info?.proyecto_nombre} />
        </Descriptions.Item>
        <Descriptions.Item label="Cargo" span={2}>
          <TextOrLoading text={info?.cargo_nombre} />
        </Descriptions.Item>
        <Descriptions.Item label="Total de contratistas en el cargo">
          <TextOrLoading text={info?.num_contratos} />
        </Descriptions.Item>
        <Descriptions.Item label="Total de productos">
          <TextOrLoading text={info?.num_productos} />
        </Descriptions.Item>
      </Descriptions>
      <br />
      {info ? (
        <>
          <Tabs
            style={{ marginTop: 15 }}
            type="card"
            defaultActiveKey="1"
            items={tabItems}
            onChange={(key) => setIrregular(key !== '1')}
            tabBarStyle={{ marginBottom: 0 }}
          />
          <br />
          <AjaxTable
            columns={columns}
            endpoint={ajaxTable}
            query={info.cargo_id}
            tableTitle="Listado de archivos"
            reloadSource={reloadSource}
            searchInput
            searchInputPlaceholder="Buscar por pago y usuario"
            pageSize={50}
            showSizeChanger
          />

          <CustomButton
            type="default"
            htmlType="button"
            className="back-button"
            text={
              <Link
                to={`${INTERNAL_LINKS.PRODUCT_APPROVAL}/role=${info.cargo_id}`}
              >
                Volver
              </Link>
            }
          />
        </>
      ) : (
        <Skeleton loading active />
      )}

      <Modal
        title={
          fileResponse?.errors !== 0
            ? 'Archivo reemplazado y verificado'
            : 'Resumen del archivo'
        }
        width="35rem"
        open={!!fileResponse}
        closable={false}
        maskClosable={false}
        footer={
          fileResponse?.errors === 0 ? (
            <>
              <CustomButton
                text="Sí, aprobar"
                type="primary"
                htmlType="button"
                block
                onClick={doAssignFile}
                disabled={loadingFRM}
                loading={loadingFRM === 1}
              />
              <CustomButton
                text="No, cancelar"
                type="danger"
                htmlType="button"
                block
                onClick={doCancelUpload}
                disabled={loadingFRM}
                loading={loadingFRM === 2}
              />
            </>
          ) : (
            <CustomButton
              text="Entendido"
              type="primary"
              htmlType="button"
              block
              onClick={() => {
                setFileResponse();
                setReloadSource({});
              }}
            />
          )
        }
        styles={{ footer: { justifyContent: 'center', display: 'flex' } }}
        destroyOnClose
      >
        {fileResponse?.unicamente_sin_tope === false ? (
          <>
            <br />
            <Text>Pago procesado: Pago {payNum}</Text>
          </>
        ) : null}
        <br />
        <Text>Errores encontrados: {fileResponse?.errors}</Text>
        <br />
        <br />
        {fileResponse?.errors === 0 ? (
          <>
            <Text className="color-primary">
              Productos por aprobar:{' '}
              <Text strong style={{ fontSize: 20 }} className="color-primary">
                {fileResponse?.count}
              </Text>
            </Text>
            <br />
            <br />
            <Text>¿Desea aprobar los productos?</Text>
          </>
        ) : (
          <Text>
            Para ver el detalle de los errores diríjase al Listado de archivos
          </Text>
        )}
      </Modal>

      <Modal
        title="Resumen y solicitud de archivo"
        width="45rem"
        open={!!summaryData}
        onCancel={() => setSummaryData()}
        footer={
          summaryData?.at(-1)['c'] <= 1 ? (
            <Alert
              type="warning"
              showIcon
              description="No puede hacer esto por masivo, diríjase a individual"
            />
          ) : (
            <CustomButton
              text="Descargar Excel"
              type="default"
              htmlType="button"
              block
              style={{ maxWidth: '15rem' }}
              onClick={downloadExcel}
              loading={loadingFile}
            />
          )
        }
        styles={{ footer: { justifyContent: 'center', display: 'flex' } }}
        destroyOnClose
      >
        <Table
          columns={summaryColumns}
          dataSource={summaryData}
          pagination={false}
        />
        <Alert
          type="warning"
          showIcon
          message="ATENCIÓN:"
          description="Use ÚNICAMENTE la plantilla que descarga de SIGA para aprobar masivamente"
        />
      </Modal>

      <Modal
        title="Detalles de contratos con restricciones"
        width="80%"
        open={detailModal}
        onCancel={() => setDetailModal()}
        destroyOnClose
        footer={null}
      >
        <AjaxTable
          columns={contractsColumns}
          endpoint={contractsTable}
          query={{
            cargo: info?.cargo_id,
            pago_numero: irregular ? null : payNum,
            ust: irregular,
          }}
          exportCSV
          searchInput
        />
      </Modal>
    </>
  );
}
